export const PATHS = {
  root: '/',

  login: '/login',
  register: '/register',
  myPage: '/mypage',

  newsList: '/news',
  newsDetail: '/news/:id',
  newsWrite: '/news/write',
  newsEdit: '/news/write/:id', 

  links: '/links',

  shops: '/shops',
  shopDetail: '/shops/:id',
  shopRegister: '/shops/register',

  etravelPickdrop: '/travel',

  inbox: '/inbox',
  inboxRoom: '/inbox/:roomId',

  adminUsers: '/admin/users',
  adminStats: '/admin/stats',

  adminServiceLinks: '/admin/service-links',

  adminLinkGroups: '/admin/link-groups',
  adminLinkGroupItems: '/admin/link-group-items',
  adminLinkGroupItemsEdit: '/admin/link-group-items/:id',

  adminShops: '/admin/shops',
};


